<div class="data-table-ctr">
  <ion-grid
    class="header-grid"
    [style.--ion-grid-columns]="
      columns | gridColCount : (checkboxSelectable ? 1 : 0)
    "
  >
    <ion-row>
      <ion-col size="1" *ngIf="checkboxSelectable">
        <ion-text
          color="secondary"
          (click)="toggleAll()"
          style="padding-left: 4px; cursor: pointer"
        >
          <fa-icon
            [icon]="['fal', 'check-square']"
            size="lg"
            *ngIf="isAllChecked()"
          ></fa-icon>
          <fa-icon
            [icon]="['fal', 'square']"
            size="lg"
            *ngIf="isNoneChecked()"
          ></fa-icon>
          <fa-icon
            [icon]="['fal', 'square-o']"
            size="lg"
            *ngIf="isSomeChecked()"
          ></fa-icon>
        </ion-text>
      </ion-col>
      <ion-col
        *ngFor="let col of columns"
        [size]="col.size"
        [class]="'ion-text-' + (col.align || 'start') + ' overflow-ellipsis'"
        [class.cursor-pointer]="col.sortable"
        (click)="col.sortable ? onSort(col) : null"
      >
        <ng-container *ngIf="col.headerTemplate; else defaultHeader">
          <div
            [ngTemplateOutlet]="col.headerTemplate"
            [ngTemplateOutletContext]="{ col: col }"
          ></div>
        </ng-container>
        <ng-template #defaultHeader>{{ col.headerName }}</ng-template>
        <ng-container *ngIf="col.sortable">
          <ion-text
            *ngIf="
              !!sortField &&
                (col.field === sortField || col.sortField === sortField);
              else sortDefault
            "
            color="primary"
          >
            <fa-icon
              [icon]="['fal', sortOrder === 'asc' ? 'sort-up' : 'sort-down']"
              size="lg"
            ></fa-icon>
          </ion-text>

          <ng-template #sortDefault>
            <ion-text color="medium">
              <fa-icon [icon]="['fal', 'sort']" size="lg"></fa-icon>
            </ion-text>
          </ng-template>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-grid
    class="data-grid"
    [style.--ion-grid-columns]="
      columns | gridColCount : (checkboxSelectable ? 1 : 0)
    "
  >
    <cdk-virtual-scroll-viewport
      [itemSize]="itemSize"
      [minBufferPx]="minBufferPx"
      [maxBufferPx]="maxBufferPx"
      class="ion-content-scroll-host"
      style="height: 100%"
    >
      <ion-progress-bar type="indeterminate" *ngIf="loading"></ion-progress-bar>
      <ion-row *ngIf="rowData?.length === 0" class="ion-text-center">
        <ion-col>
          <i>
            <small>{{ noItemsText || 'Geen items' }}</small>
          </i>
        </ion-col>
      </ion-row>
      <ion-row
        [ngClass]="isBoldFirstColumn && !row?.isGroupHeader ? 'column' : ''"
        *cdkVirtualFor="
          let row of rowData;
          trackBy: trackByFn;
          odd as odd;
          index as index
        "
        (click)="rowClicked(row)"
        [class.dark-row]="odd && !row?.isGroupHeader"
        [class.group-header-row]="row?.isGroupHeader"
        #viewport
      >
        <ion-col
          *ngIf="row?.isGroupHeader"
          class="group-header-col"
          [size]="columns | gridColCount : (checkboxSelectable ? 1 : 0)"
        >
          <ion-text color="primary">
            <strong>{{ row.groupHeaderLabel }}</strong>
          </ion-text>
        </ion-col>

        <ng-container *ngIf="!row?.isGroupHeader">
          <ion-col
            size="1"
            *ngIf="checkboxSelectable"
            clickStopPropagation
            (click)="check(row)"
          >
            <ion-text [color]="isChecked(row) ? 'primary' : 'secondary'">
              <fa-icon
                [icon]="['fal', 'check-square']"
                size="lg"
                *ngIf="isChecked(row)"
              ></fa-icon>
              <fa-icon
                [icon]="['fal', 'square']"
                size="lg"
                *ngIf="!isChecked(row)"
              ></fa-icon>
            </ion-text>
          </ion-col>
          <ion-col
            *ngFor="let col of columns"
            [size]="col.size"
            [class]="'ion-text-' + (col.align || 'start') + ' overflow-ellipsis' + (col.cssClass ? ' ' + col.cssClass : '')"
            class="text_col"
          >
            <ng-container *ngIf="!col.template">
              <ion-text [color]="row | colColor : col">
                {{ row | displayCellData : col }}
              </ion-text>
            </ng-container>
            <div
              *ngIf="col.template"
              [ngTemplateOutlet]="col.template"
              [ngTemplateOutletContext]="{
                rows: rowData,
                value: row | displayCellData : col,
                row: row,
                index: index
              }"
            ></div>
          </ion-col>
        </ng-container>
      </ion-row>
      <ion-infinite-scroll
        threshold="100px"
        (ionInfinite)="loadData($event)"
        #infiniteScroll
        *ngIf="useInfiniteScroll"
      >
        <ion-infinite-scroll-content
          loadingSpinner="lines-sharp-small"
          loadingText="loading"
        >
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </cdk-virtual-scroll-viewport>
  </ion-grid>
  <div class="footer-grid" *ngIf="displayFooter">
    <div class="footer-inner">
      <div class="footer-total">
        <span>Totaal aantal: <span>{{ totalNumberOfRows }}</span></span>
        <ion-text color="primary" *ngIf="footerChange === 'added'" class="footer-change-icon">
          <fa-icon [icon]="['fass', 'caret-up']" size="xl"></fa-icon>
        </ion-text>
        <ion-text color="danger" *ngIf="footerChange === 'removed'" class="footer-change-icon">
          <fa-icon [icon]="['fass', 'caret-down']" size="xl"></fa-icon>
        </ion-text>
      </div>
      <span *ngIf="footerEndText" class="footer-end-text">{{ footerEndText }}</span>
    </div>
  </div>
</div>
